export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (707ff386)";
export var GIT_SHA = "707ff386";
export var THEME = "open-source-visual-refresh";
export var SYSTEM = "console";
export var ALWAYS_VISUAL_REFRESH = true;